// extracted by mini-css-extract-plugin
module.exports = {"container":"_3UYhzA","externalLinksGroup":"btLC02","externalLink":"_35eUuR","text":"tKz1N2"};